// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__3xKlh","submenuRight":"Submenu_submenuRight__tGiRc"};